import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";

@Component({
  selector: "app-data-type-access-rights",
  templateUrl: "./data-type-access-rights.component.html",
  styleUrl: "./data-type-access-rights.component.scss",
})
export class DataTypeAccessRightsComponent {
  customValue: string = "";
  accessRights = [
    {
      enabled: true,
      profileName: "Default with OTHER code",
    },
    {
      enabled: false,
      profileName: "MET",
    },
  ];

  accessDisplayedColumns: string[] = [
    "enable",
    "profileName",
  ];

  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<DataTypeAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { value: string; dataType: string }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close();
  }
openAddProfileDialog(): void {
  const dialogRef = this.dialog.open(AddProfileDialogComponent, {
    width: '400px',
    data: {}
  });

  dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
    if (selectedProfiles && selectedProfiles.length) {
      selectedProfiles.forEach(profile => {
        const exists = this.accessRights.some(p => p.profileName === profile.name);
        if (!exists) {
          this.accessRights.push({
            enabled: false,
            profileName: profile.name
          });
        }
      });

      this.accessRights.sort((a, b) => a.profileName.localeCompare(b.profileName));

      this.accessRights = [...this.accessRights];
    }
  });
}

}
